"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.22.1
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { clsx } from 'clsx';
import { SvgIconType } from '../SvgIcon/svg-icon-type.mjs';
import useEventStopPropagation from '../../helpers/hooks/useEventStopPropagation.mjs';
import '../../styled-system/css/css.mjs';
import '../../styled-system/helpers.mjs';
import { sva } from '../../styled-system/css/sva.mjs';
import { SvgIcon } from '../SvgIcon/index.mjs';
import { Tooltip } from '../Tooltip/index.mjs';

const dataBuilderActionBarRecipe = sva({
  className: "data-builder-action-bar",
  slots: ["root", "button"],
  base: {
    root: {
      display: "flex",
      flexDir: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "1",
      w: "5",
      ml: "-0.5",
      mr: "-2.5"
    },
    button: {
      display: "flex",
      flexShrink: "0",
      flexGrow: "0",
      justifyContent: "center",
      alignItems: "center",
      w: "5",
      h: "5",
      border: "1px",
      borderStyle: "solid",
      borderColor: "gray.6",
      bg: "slate.2",
      color: "slate.10",
      _hover: {
        bg: "slate.4"
      },
      "& > svg": {
        w: "3",
        h: "3",
        strokeWidth: "2"
      }
    }
  }
});
const ActionBarRoot = forwardRef(
  ({ children, className, ...props }, ref) => {
    const styles = dataBuilderActionBarRecipe();
    return /* @__PURE__ */ jsx("div", { className: clsx(styles.root, className), ...props, ref, children });
  }
);
ActionBarRoot.displayName = "ActionBarRoot";
const ActionBarDeleteButton = forwardRef(
  ({ className, onClick, ...props }, ref) => {
    const styles = dataBuilderActionBarRecipe();
    const handleOnClick = useEventStopPropagation(
      (e) => onClick?.(e)
    );
    return /* @__PURE__ */ jsx(Tooltip, { tooltip: "Delete", className: styles.root, usePortal: true, children: /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: clsx(styles["button"], className),
        onClick: handleOnClick,
        "aria-label": "Delete",
        ...props,
        ref,
        children: /* @__PURE__ */ jsx(SvgIcon, { type: SvgIconType.Close })
      }
    ) });
  }
);
ActionBarDeleteButton.displayName = "ActionBarDeleteButton";
const ActionBar = Object.assign(ActionBarRoot, {
  DeleteButton: ActionBarDeleteButton
});

export { ActionBar, dataBuilderActionBarRecipe };
